module.exports = __webpack_public_path__ + "img/edit-white.e3551964.svg";